import AstroReportImage from "@/assets/img/modal/astro_report.webp"
import { STAR_REPORT_MODAL_V2_PLAN_ID } from "@/features/subscriptions/report-plan-codes"
import { ReportIds } from "@/features/today/config/reports-data"

import type { AppModalComponentProps } from "../config/modal-registry"
import { ReportPromoModalV2, type ReportPromoCopyV2 } from "./report-promo-modal-v2"

const COPY: ReportPromoCopyV2 = {
  reportId: ReportIds.Astrology,
  planId: STAR_REPORT_MODAL_V2_PLAN_ID,
  title: "Get Astrology Report",
  description:
    "Discover what your stars reveal about your personality, timing, relationships, and future path",
  image: AstroReportImage,
  withZodiacOverlay: true,
}

export function ReportAstrologyModalV2(props: AppModalComponentProps) {
  return <ReportPromoModalV2 {...props} copy={COPY} />
}
